module.exports = __webpack_public_path__ + "img/complete.248d6b85.svg";